import type { ReactNode } from 'react'
import { cn } from '~/shared/lib/utils'
import { Card } from '~/shared/ui/card'
import { AuthControlPanel } from './auth-control-panel'

export function AuthShell({
  children,
  footer,
  className,
}: {
  children: ReactNode
  footer?: ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        'beacon-canvas flex min-h-dvh flex-col items-center px-4 pt-20 pb-16 sm:justify-center sm:pt-16',
        className,
      )}
    >
      <AuthControlPanel />
      <main className="beacon-enter flex w-full max-w-[400px] flex-col gap-6">
        <img src="/pulsify-wordmark.svg" alt="Pulsify" className="h-7 w-auto self-center" />
        <Card className="flex flex-col gap-6 p-6 sm:p-8">{children}</Card>
        {footer ? (
          <div className="flex flex-col items-center gap-2 text-balance text-center text-muted-foreground text-sm">
            {footer}
          </div>
        ) : null}
      </main>
    </div>
  )
}

export function AuthHeading({
  title,
  description,
  icon,
}: {
  title: string
  description?: ReactNode
  icon?: ReactNode
}) {
  return (
    <div className="flex flex-col gap-2">
      {icon ? (
        <span className="squircle mb-2 flex size-10 items-center justify-center rounded-xl bg-muted text-foreground [&_svg]:size-5">
          {icon}
        </span>
      ) : null}
      <h1 className="text-balance font-semibold text-2xl text-foreground leading-tight tracking-[-0.025em] sm:text-[30px]">
        {title}
      </h1>
      {description ? (
        <p className="text-muted-foreground text-sm sm:text-base">{description}</p>
      ) : null}
    </div>
  )
}

export const authLinkClassName =
  'font-medium text-foreground underline decoration-foreground/30 underline-offset-4 transition-colors hover:decoration-foreground'
